<template>
  <div>
    <div v-if="isLoading" class="Loader isActive py-5">
      <div class="Loader-content">
        <div class="ball-spin-fade-loader">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>

    <div v-else>
      <div class="row mx-n2">
        <div
          class="col-md-6 col-lg-4 px-2 mb-3"
          v-for="filter in dataSource"
          :key="filter.Id"
        >
          <button
            :class="[
              'LpCareerInternshipListFilterButton btn btn-block shadow-none font-weight-semi-bold py-2'
            ]"
            @click.prevent="applyFilter(filter.Id)"
          >
            {{ filter.Text }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isLoading: true,
      filterValue: '',
      dataSource: []
    }
  },
  methods: {
    applyFilter (id) {
      this.filterValue = id

      // emit filter
      this.$emit('applyFilter', this.filterValue)

      // redirect to jobs.cz
      const jobsUrl = new URL('https://euc.jobs.cz/staze')

      if (this.filterValue.length) {
        // apply filter
        const foundInternship = this.dataSource.find(
          internship => internship.Id === this.filterValue
        )

        if (foundInternship?.LinkText?.length) {
          jobsUrl.searchParams.set('custom_staze', foundInternship.LinkText)
        }
      }

      // open jobs in new tab
      window.open(jobsUrl, '_self')
    },
    getData () {
      axios
        .get('/umbraco/Api/Internship/GetTypes')
        .then(response => {
          const { data } = response

          this.dataSource = data
        })
        .catch(err => {
          console.error(err)
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  },
  mounted () {
    this.getData()
  }
}
</script>
